<kiwi-decision-content (saved)="save()">
    <div class="cell auto grid-x grid-margin-x">
        <div class="cell auto grid-y">
            <fieldset class="cell auto">
                <legend [i18nKey]="'decisions.animator.mark'"></legend>
                <kiwi-animator-mark-explanation></kiwi-animator-mark-explanation>
                <div class="menuSalesPrices-content">
                    <table class="cell auto _tableColor">
                        <tbody>
                        <tr class="_titlePartTable">
                            <td [i18nKey]="'decisions.animator.mark.weight'"></td>
                            <td class="_number"[i18nKey]="'decisions.animator.mark'"></td>
                        </tr>
                        <tr>
                            <td>{{parameters * 100}} %</td>
                            <td><kiwi-mark-input [(ngModel)]="decision" [disabled]="decisionsReadonly" (change)="onValueUpdate()"></kiwi-mark-input></td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </fieldset>
        </div>
    </div>
</kiwi-decision-content>
